import React from 'react';
import ReactMarkdown from 'react-markdown';
import { cn } from '../../../../lib/utils';
import { NarrativeBlock as NarrativeBlockType } from '../../../../types/report-builder';

interface Props {
  block: NarrativeBlockType;
}

const NarrativeBlock: React.FC<Props> = ({ block }) => {
  const style = block.style ?? 'default';

  return (
    <div
      className={cn(
        'my-6 rounded-[24px] border border-border/70 bg-card p-5 text-foreground shadow-[var(--shadow-card)] prose prose-sm max-w-none',
        style === 'callout' && 'bg-[var(--go-good-vibes-tint)]/55',
        style === 'insight' && 'border-l-4 border-primary/40 pl-4'
      )}
    >
      <ReactMarkdown>{block.markdown}</ReactMarkdown>
    </div>
  );
};

export default NarrativeBlock;
